/**
 * API Cliente Maestro operativo (≠ comprador SaaS, ≠ /api/clients fiscal).
 */
import api from "@/lib/api";
import { DESPACHO_WRITE_FORBIDDEN_MESSAGE } from "@/modules/despacho/despachoPermissions";

export const CLIENT_MASTER_API_PATH = "/client-master";

export const FORBIDDEN_CLIENT_MASTER_MESSAGE =
  "No tienes habilitado Gestión Despacho para operar Cliente Maestro.";

export const DUPLICATE_CLIENT_MASTER_RFC_MESSAGE =
  "Ya existe un Cliente Maestro con este RFC en tu espacio.";

export const LOAD_CLIENT_MASTER_ERROR = "No pudimos cargar Cliente Maestro.";

export const CLIENT_MASTER_SAT_NOTICE =
  "Este catálogo corresponde a clientes operativos del comprador. No modifica SAT ni activa descargas.";

export const CLIENT_MASTER_BUYER_NOTICE =
  "Cliente Maestro unifica clientes operativos (contribuyentes administrados por el comprador). El comprador SaaS se administra en Centro SaaS / Diseñador.";

/**
 * @param {import('axios').AxiosError|Error} err
 */
export function parseClientMasterError(err) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;

  if (status === 403) {
    const code = typeof detail === "object" && detail?.code;
    if (code === "DESPACHO_WRITE_FORBIDDEN") {
      return { kind: "write_forbidden", message: DESPACHO_WRITE_FORBIDDEN_MESSAGE };
    }
    if (code === "MODULE_NOT_LICENSED" || code === "LICENSE_BLOCKED") {
      return { kind: "forbidden", message: FORBIDDEN_CLIENT_MASTER_MESSAGE };
    }
    return { kind: "forbidden", message: FORBIDDEN_CLIENT_MASTER_MESSAGE };
  }

  if (status === 409) {
    const code = typeof detail === "object" && detail?.code;
    if (code === "CLIENT_MASTER_DUPLICATE_RFC") {
      return { kind: "duplicate_rfc", message: DUPLICATE_CLIENT_MASTER_RFC_MESSAGE };
    }
    return { kind: "duplicate_rfc", message: DUPLICATE_CLIENT_MASTER_RFC_MESSAGE };
  }

  if (status === 404) {
    return { kind: "not_found", message: "Cliente Maestro no encontrado." };
  }

  if (status === 422) {
    const msg = typeof detail === "string" ? detail : "Datos inválidos.";
    return { kind: "validation", message: msg };
  }

  return { kind: "error", message: LOAD_CLIENT_MASTER_ERROR };
}

export function createClientMasterApi(httpClient = api) {
  return {
    async list(params = {}) {
      const { data } = await httpClient.get(CLIENT_MASTER_API_PATH, { params });
      return Array.isArray(data?.items) ? data.items : [];
    },

    async get(masterId) {
      const { data } = await httpClient.get(`${CLIENT_MASTER_API_PATH}/${masterId}`);
      return data;
    },

    async create(payload) {
      const { data } = await httpClient.post(CLIENT_MASTER_API_PATH, payload);
      return data;
    },

    async update(masterId, payload) {
      const { data } = await httpClient.patch(`${CLIENT_MASTER_API_PATH}/${masterId}`, payload);
      return data;
    },

    async updateDespachoLink(masterId, despachoConfig) {
      const { data } = await httpClient.patch(
        `${CLIENT_MASTER_API_PATH}/${masterId}/module-links/despacho`,
        despachoConfig,
      );
      return data;
    },
  };
}

export const clientMasterApi = createClientMasterApi();
